// Colores inspirados en PayPal (Navy Blue dominante y Celeste PayPal)
export const colors = {
  primary: {
    main: '#0A2540', // Azul marino profundo (PayPal Navy)
    light: '#1E3E60',
    dark: '#051220',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#0070E0', // Celeste PayPal (PayPal Blue)
    light: '#1A8CFF',
    dark: '#004B99',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#00B074', // Verde esmeralda sleek
    light: '#33C090',
    dark: '#008C5C',
  },
  error: {
    main: '#D9381E', // Rojo PayPal soft
    light: '#E1604B',
    dark: '#AD2D18',
  },
  warning: {
    main: '#F5B300', // Amarillo cálido
    light: '#F7C233',
    dark: '#C48F00',
  },
  info: {
    main: '#0070E0',
    light: '#1A8CFF',
    dark: '#004B99',
  },
  background: {
    default: '#F5F7FA', // Gris claro ultra limpio
    paper: '#FFFFFF',   // Blanco puro para tarjetas
    dark: '#0A2540',
  },
  text: {
    primary: '#1C2B39',   // Azul/gris oscuro premium
    secondary: '#6C7C8C', // Gris azulado suave
    disabled: '#A6B3C0',
  },
};

export const gradients = {
  primary: 'linear-gradient(135deg, #0A2540 0%, #0070E0 100%)',
  secondary: 'linear-gradient(135deg, #0070E0 0%, #004B99 100%)',
  success: 'linear-gradient(135deg, #00B074 0%, #008C5C 100%)',
  info: 'linear-gradient(135deg, #0070E0 0%, #1E3E60 100%)',
};
